<template>
  <div class="pa-10">
    Create QR Code using this page
    <v-text-field v-model="qrCodeUrl" outlined />
    <v-btn @click="downloadQrCode">Download QR Code</v-btn>
  </div>
</template>

<script>
import QrCodeGenerator from "@/services/QrCodeGenerator";

export default {
  name: "QrCodeTool",
  data() {
    return {
      qrCodeUrl: ''
    }
  },
  methods: {
    async downloadQrCode() {
      await QrCodeGenerator.generateQrCode(this.qrCodeUrl, 'qrcode.png')
    }
  }
}
</script>

<style scoped>

</style>